import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  codeCodebookTypeList: [],
  codebookTypeComposite: [],
  codebookType: null,
  loading: false,
  error: undefined,
  totalElements: '',
};

const codeCodebookTypeSlice = createSlice({
  name: 'codeCodebookType',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setCodeCodebookTypeList(state, action) {
      state.attributeList = action.payload;
      state.loading = false;
    },
    addCodebookType(state, action) {
      state.codeCodebookTypeList = [action.payload].concat(
        state.codeCodebookTypeList
      );
      state.error = undefined;
      state.loading = false;
    },
    updateCodebookType(state, action) {
      const data = action.payload;
      state.codeCodebookTypeList = state.codeCodebookTypeList.map(
        (codebookType) => {
          if (codebookType.id === data.parentCodebookTypeId) {
            return {
              ...codebookType,
              childrenCodebookTypes: codebookType.childrenCodebookTypes?.map(
                (child) => (child.id === data.id ? data : child)
              ),
            };
          }
          return codebookType.id === data.id ? data : codebookType;
        }
      );
      state.error = undefined;
      state.loading = false;
    },
    deleteCodebookType(state, action) {
      state.codeCodebookTypeList = state.codeCodebookTypeList.filter(
        (codebookType) => codebookType.id !== action.payload
      );
      state.error = undefined;
      state.loading = false;
    },
    setCodebookType(state, action) {
      state.codebookType = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    fetchAllCodebookTypesComposite(state, action) {
      state.codebookTypeComposite = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    activateCodebookType(state, action) {
      state.codeCodebookTypeList = state.codeCodebookTypeList.map(
        (codebookType) =>
          codebookType.id === action.payload.id ? action.payload : codebookType
      );
      state.error = undefined;
      state.loading = false;
    },
    deactivateCodebookType(state, action) {
      state.codeCodebookTypeList = state.codeCodebookTypeList.map(
        (codebookType) =>
          codebookType.id === action.payload.id ? action.payload : codebookType
      );
      state.error = undefined;
      state.loading = false;
    },
    clearCodebookTypeList(state) {
      state.codeCodebookTypeList = [];
      state.error = undefined;
      state.loading = false;
    },
    clearCodebookType(state) {
      state.codebookType = {};
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const codeCodebookTypeActions = codeCodebookTypeSlice.actions;

export default codeCodebookTypeSlice.reducer;
